import {createStrokeSVG} from './TEMPLATE'

// tabler: loader-2
export const Loader_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M12 3a9 9 0 1 0 9 9'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
